import { v4 as uuidv4 } from "uuid";

export default function listReducer(moodboards, action) {
  switch (action.type) {
    case "SET_MOODBOARDS":
      return action.payload;

    case "ADD_MOODBOARD":
      const boardToAdd = { ...action.payload, id: uuidv4() };
      //console.log(moodboards);
      //console.log(boardToAdd);
      return [...moodboards, boardToAdd]; // add board to front of list

    case "UPDATE_MOODBOARD":
      const index = moodboards.findIndex(
        (moodboard) => moodboard.id === action.payload.id
      );
      let updatedMoodboards = [...moodboards]; // important to create a copy, otherwise you'll modify state outside of setState call
      updatedMoodboards[index] = {
        ...updatedMoodboards[index],
        ...action.payload,
      };
      return updatedMoodboards;

    case "REMOVE_MOODBOARD":
      return moodboards.filter(
        (moodboard) => moodboard.id !== action.payload.id
      );

    default:
      return moodboards;
  }
}
